"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryImageWrapper = exports.FiftyFiftyBanner = exports.ContentWrapper = exports.BannerImage = exports.BannerContent = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreMixins = require("@vfuk/core-mixins");
var _FiftyFiftyBanner = _interopRequireDefault(require("../themes/FiftyFiftyBanner.theme"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var FiftyFiftyBanner = _styledComponents["default"].div.withConfig({
  displayName: "FiftyFiftyBannerstyle__FiftyFiftyBanner",
  componentId: "sc-t9g7ex-0"
})(function (props) {
  var localTheme = (0, _FiftyFiftyBanner["default"])(props.theme);
  return (0, _styledComponents.css)(["display:flex;flex-direction:column-reverse;background:", ";min-height:", "px;", " ", ""], localTheme.appearance[props.appearance].backgroundColor, localTheme.height.sm, _coreMixins.respondTo.md((0, _styledComponents.css)(["min-height:", "px;"], localTheme.height.md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["flex-direction:row;", ""], props.bodyPosition === 'right' && "\n        flex-direction: row-reverse;\n      ")));
});
exports.FiftyFiftyBanner = FiftyFiftyBanner;
var BannerContent = _styledComponents["default"].div.withConfig({
  displayName: "FiftyFiftyBannerstyle__BannerContent",
  componentId: "sc-t9g7ex-1"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;display:flex;align-items:center;justify-content:flex-end;padding:", "px;", " ", ""], props.theme.spacing.responsive[3].sm, _coreMixins.respondTo.md((0, _styledComponents.css)(["padding:", "px;"], props.theme.spacing.responsive[5].md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["padding:", "px;width:50%;", " ", ""], props.theme.spacing.responsive[10].lg, props.bodyPosition === 'left' && (0, _styledComponents.css)(["padding-left:0;justify-content:flex-end;"]), props.bodyPosition === 'right' && (0, _styledComponents.css)(["padding-right:0;justify-content:flex-start;"]))));
});
exports.BannerContent = BannerContent;
var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FiftyFiftyBannerstyle__ContentWrapper",
  componentId: "sc-t9g7ex-2"
})(function () {
  return (0, _styledComponents.css)(["width:100%;", ""], _coreMixins.respondTo.lg((0, _styledComponents.css)(["max-width:440px;"])));
});
exports.ContentWrapper = ContentWrapper;
var BannerImage = _styledComponents["default"].div.withConfig({
  displayName: "FiftyFiftyBannerstyle__BannerImage",
  componentId: "sc-t9g7ex-3"
})(function (props) {
  var localTheme = (0, _FiftyFiftyBanner["default"])(props.theme);
  return (0, _styledComponents.css)(["width:100%;display:flex;justify-content:center;align-items:center;padding:", "px;position:relative;min-height:240px;", " ", " ", " ", ""], props.theme.spacing.responsive[3].sm, props.verticalAlign && (0, _styledComponents.css)(["", " ", ""], props.verticalAlign === 'top' && (0, _styledComponents.css)(["padding-top:0;align-items:flex-start;"]), props.verticalAlign === 'bottom' && (0, _styledComponents.css)(["padding-bottom:0;align-items:flex-end;"])), _coreMixins.respondTo.md((0, _styledComponents.css)(["min-height:", "px;padding:", "px;", ""], localTheme.height.md, props.theme.spacing.responsive[6].md, props.verticalAlign && (0, _styledComponents.css)(["", " ", ""], props.verticalAlign === 'top' && (0, _styledComponents.css)(["padding-top:0;"]), props.verticalAlign === 'bottom' && (0, _styledComponents.css)(["padding-bottom:0;"])))), _coreMixins.respondTo.lg((0, _styledComponents.css)(["width:50%;"])), props.backgroundImage && (0, _styledComponents.css)(["", ""], (0, _coreMixins.backgroundImage)(props.backgroundImage)));
});
exports.BannerImage = BannerImage;
var SecondaryImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FiftyFiftyBannerstyle__SecondaryImageWrapper",
  componentId: "sc-t9g7ex-4"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;bottom:0;max-width:200px;", ":0;"], props.bodyPosition);
});
exports.SecondaryImageWrapper = SecondaryImageWrapper;